import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/impact', label: 'Business Impact' },
    { path: '/awards', label: 'Awards & Credentials' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <header className="fixed top-0 w-full bg-white border-b border-gray-200 z-50 h-20 shadow-sm">
      <div className="container mx-auto px-[7.6923%] h-full flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 group">
          <div className="w-12 h-12 bg-[#085041] flex items-center justify-center group-hover:bg-[#0A5F4C] transition-colors duration-400">
            <span className="text-[#E1F5EE] text-2xl font-bold">CX</span>
          </div>
          <span className="text-gray-900 text-2xl font-semibold tracking-tight">Sage</span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-[18px] font-normal transition-colors duration-300 ${
                location.pathname === link.path
                  ? 'text-[#00D4B4]'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="bg-[#00D4B4] text-white px-6 py-3 text-[18px] font-medium hover:bg-[#00BFA3] transition-all duration-400"
            style={{ borderRadius: '0px' }}
          >
            Get Started
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden text-gray-900 p-2"
        >
          {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-b border-gray-200">
          <nav className="container mx-auto px-[7.6923%] py-6 flex flex-col gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`text-[18px] font-normal transition-colors duration-300 py-2 ${
                  location.pathname === link.path
                    ? 'text-[#00D4B4]'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setMobileMenuOpen(false)}
              className="bg-[#00D4B4] text-white px-6 py-3 text-[18px] font-medium hover:bg-[#00BFA3] transition-all duration-400 text-center mt-2"
              style={{ borderRadius: '0px' }}
            >
              Get Started
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;